<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import VueMq from 'vue-mq';
import PortalVue from 'portal-vue';
/*  */
import Menu from '@/components/Menu';
import ModalMenu from '@/components/modal/ModalMenu';
import ModalError from '@/components/modal/ModalError';
/*  */
import { setToken } from '@/scripts/axios';
import routes from '@/scripts/constants/menu';
import styleVariables from '@/styles/variables.scss';
import { mobile } from '@/scripts/computed';
import { getProfile } from '@/scripts/api/account';
import { goTo } from '@/scripts/methods';
import { getGames } from '@/scripts/api/games';
import { unlockScroll, lockScroll } from '@/scripts/utils/dom';
import { clearAll } from '@/scripts/utils/store-dependent';
import { wsConnection } from '@/scripts/modules/ws';

const mobileIncludeBreakpoint = parseInt(styleVariables.desktop);

/* > */
Vue.use(PortalVue);
Vue.use(VueMq, {
  breakpoints: {
    mobile: mobileIncludeBreakpoint,
    desktop: Infinity,
  },
});
/* < */

export default {
  name: 'App',
  components: {
    Menu,
    ModalMenu,
    ModalError,
  },
  data() {
    return {};
  },
  watch: {
    modalBlur(val) {
      if (val) {
        lockScroll();
      } else {
        this.$nextTick(function() {
          unlockScroll();
        });
      }
    },
  },
  computed: {
    ...mapState(['language', 'user', 'games', 'showModalMenu', 'error']),
    ...mapGetters(['modalBlur']),
    mobile,
  },
  created() {
    this.auth();
    getGames().then(games => this.setGames(games.items));

    this.routes = routes;

    this.checkLanguage();
  },
  mounted() {},
  methods: {
    ...mapActions({
      setLanguage: 'setLanguage',
      setUser: 'setUser',
      setGames: 'setGames',
    }),
    auth() {
      const token = localStorage.getItem('token');

      if (!token) return;

      setToken(token);

      getProfile()
        .then(user => {
          this.setUser(user);
          wsConnection.setToken(token);
          wsConnection.connect('users');
        })
        .catch(clearAll);
    },
    checkLanguage() {
      this.setLanguage('en');

      /* TODO: next release */
      /* import { checkLanguage } from '@/scripts/language'; */
      /* const { language: languageStore } = this;
      const newLanguage = checkLanguage(languageStore);

      if (newLanguage) this.setLanguage(newLanguage); */
    },
    goTo,
  },
};
</script>

<template>
  <div id="app" :class="{ app: true, 'modal-open': modalBlur }">
    <div class="wrapper">
      <Menu
        v-if="routes.some(({ name }) => $route.name && $route.name === name)"
      />
      <!--  -->
      <div class="pages" v-if="games">
        <router-view class="pages__wrapper" />
      </div>
      <!-- modals -->
      <ModalMenu v-if="mobile && showModalMenu" />
      <ModalError v-if="error" />
    </div>
    <portal-target name="modalBlur"></portal-target>
  </div>
</template>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/global.scss';
html {
  box-sizing: border-box;
  min-height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

body {
  min-height: 100vh;
  height: 100%;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #0e0e0e;
}

#app {
  height: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

/*  */
.modal-open {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  position: fixed;
  width: 100%;
  height: 100%;

  .wrapper {
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(14, 15, 15, 0.5);
    }
  }
}

.wrapper {
  display: flex;
  flex-grow: 1;
  background-image: linear-gradient(147deg, #0d0d0d 9%, #192021 102%);
  height: 100%;
}

.pages {
  flex-grow: 1;
  font-family: Poppins-Medium;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__wrapper {
    display: flex;
    width: 100%;
    flex-grow: 1;
    flex-direction: column;
  }
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__content {
    flex-grow: 1;
  }
}

.container {
  padding: 0 20px;
  width: 100%;
  max-width: 1210px;
  margin: 0 auto;
}

@media (max-width: $mobile) {
  body {
    min-height: auto;
  }
}
</style>
